import config from "./config.js";

function getSeatingMapModule() {
  if (typeof window !== "undefined" || config("INTEGRATION_TEST")) {
    return require("../node_modules/@humanitix/humanitix-seating-map/dist/bundle.js");
  }
  return {
    Views: {
      SeatingConstruction: {},
      SectionOverview: {},
      SeatingReservation: {},
      SeatingManagement: {}
    },

    Utils: {
      tableElements: {},
      Config: {},
      ToolBarInterface: {},
      LabelGenerator: {}
    },
    State: {
      Reservation: {
        ReservationManager: {},
        ReservationStateChangeTracker: {},
        ReservationState: {}
      },
      Assigning: {
        AssigningManager: {},
        AssigningStateChangeTracker: {},
        AssigningState: {},
        MODES: {}
      }
    }
  };
}
const {
  Views,
  Utils,
  State,
  SeatingMap,
  AttendeeSearchResults
} = getSeatingMapModule();

export { Views, Utils, State, SeatingMap, AttendeeSearchResults };
